<template>
  <div id="skill-page">
    <div>
      <table style="margin: 0 auto;margin-top: 20px">
        <tr>
          <td>
            <label>Skill</label>
          </td>
          <td>
            <select v-model="skillId">
              <option
                v-bind:key="service.id"
                v-for="service in services"
                v-bind:value="service.id"
              >{{service.localizedTitle.lt}}</option>
            </select>
          </td>
        </tr>
        <tr>
          <td>
            <label>ID</label>
          </td>
          <td>
            <input type="text" v-model="jobId" />
          </td>
        </tr>
        <tr>
          <td>
            <label>Duration Estimate (mins)</label>
          </td>
          <td>
            <input type="text" v-model="duration" />
          </td>
        </tr>
        <tr>
          <td>
            <label>Unit Price EUR</label>
          </td>
          <td>
            <input type="text" disabled v-model="price" />
          </td>
        </tr>
        <tr>
          <td>
            <label>Unit Price PLN</label>
          </td>
          <td>
            <input type="text" v-model="pricePl" />
          </td>
        </tr>
        <tr>
          <td>
            <label style="font-weight: bold;">Unit Price 2 EUR</label>
          </td>
          <td>
            <input type="text" v-model="price2" />
          </td>
        </tr>
      </table>

      <button
        v-on:click="saveJob()"
        style="background-color: #333;color: white; padding:10px;cursor:pointer;margin-top:20px"
      >Save job</button>
    </div>
  </div>
</template>

<style scoped lang="less">
#skill-page {
  input {
    padding: 10px;
  }
  table {
    td {
      border: 1px solid #999;
      border-collapse: collapse;
      margin: 0;
      padding: 10px;
    }
  }
}
</style>

<script>
import * as storeReader from "../services/storeReader";
import api from "../services/api";
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'

export default {
  name: "home",
  data: function () {
    return {
      storeReader,
      price: 0,
      price2: 0,
      pricePl: 0,
      duration: 0,
      skillId: '',
      jobId: '',
      pros: [],
      services: [],
    };
  },
  created: async function() {
    const state = this.$store.state;
    this.services = state.skills;
    const id = this.$route.params.id;
    console.log(id);
    if (id) {
      const jobs = await api.getJobs();
      for (let i = 0; i < jobs.length; i++) {
        if (jobs[i].id === id) {
          const job = jobs[i];
          const unitPrice = Object.assign({LT: {EUR: 0}, PL: {PLN: 0}}, job.unitPrice || {});
          const unitPrice2 = Object.assign({LT: {EUR: 0}, PL: {PLN: 0}}, job.unitPrice2 || {});
          this.price = (unitPrice.LT.EUR / 100).toFixed(2);
          this.pricePl = (unitPrice.PL.PLN / 100).toFixed(2);
          this.price2 = (unitPrice2.LT.EUR / 100).toFixed(2);
          this.skillId = job.skillId;
          this.duration = job.durationEstimate;
          this.jobId = job.id;
        }
      }
    }
  },
  methods: {
    saveJob: async function () {
      const getJobData = () => {
        return {
          durationEstimate: parseInt(this.duration),
          skillId: this.skillId,
          unitPrice: {
             LT: {
               EUR: Math.round(parseFloat(this.price) * 100)
             },
             PL: {
               PLN: Math.round(parseFloat(this.pricePl) * 100)
             }
          },
          unitPrice2: {
            LT: {
              EUR: Math.round(parseFloat(this.price2) * 100)
            },
            PL: {
              PLN: Math.round(parseFloat(this.pricePl) * 100)
            }
          }
        };
      };
      const data = getJobData();
      if (this.$route.params.id == "new") {
        await api.createJob(this.jobId, data);
      } else {
        await api.createJob(this.jobId, data);
      }
      this.$router.push({ name: "jobs" }).catch(() => {});
    },
  },
};
</script>
